<template>
  <div>
    <connect-icon />
    <h5 class="text-center">{{ $t("imports.lms.canvas") }}</h5>
    <p class="text-center">
      {{ $t("imports.canvasIntroDescription") }}
    </p>
    <eg-b-alert show variant="secondary">
      <div>{{ $t("imports.dontForget") }}</div>
      {{ $t("imports.noChangesToCanvas") }}
    </eg-b-alert>
  </div>
</template>

<script>
import ConnectIcon from "../icons/connect-icon.vue";

export default {
  components: { ConnectIcon },
};
</script>
